<template>
  <div class="malib-classify clearfix">
    <a v-if="malibConf.data.length > 0"
       v-for="item in malibConf.data"
       @click="cut(item.id)"
       href="javascript:;"
       class="btn" :class="{'act': item.id === malibConf.id}">
      <i class="type-ico" :class="commonMethods.getMalibClassify(item)"></i>
      <span v-text="item.name"></span>
    </a>
  </div>
</template>

<script>
  import {ComponentName, Methods, CdnLibrary} from '../const/common';

  export default {
    name: "malib_classify",
    props: ['malibConf'],
    data() {
      return {
        commonMethods: Methods
      }
    },
    methods: {
      cut(id) {
        this.$emit('cut', {id, type: 2, pading: false});
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/malib_classify.vue